<template>
  <div>
    <loading 
     :active.sync="loadingNetwork" 
        :is-full-page="true"
        color="grey"
        ></loading>
    <v-toolbar flat color="white">
      <h2 class="dark-grey--text px-2 pt-3">{{locationnetworksummary.name}}</h2>
      <v-spacer></v-spacer>
      <customerimport
        v-if="$route.params.locationNetworkId"
        :location-network-id="$route.params.locationNetworkId"
        :network-name="locationnetworksummary.name"
        @imported="fetchLocationNetworksLocations(); fetchCustomers()"
      ></customerimport>
      <nmssync
        v-if="$route.params.locationNetworkId"
        class="ml-2"
        :location-network-id="$route.params.locationNetworkId"
        :network-name="locationnetworksummary.name"
      ></nmssync>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>
    <!-- <div v-if="displayContents('locationNetworkSummary')&&pageLoaded">
      <locationnetworksummarypage
        :locationnetworksummarypage="unitsPassedNetworkSummary"
        :locationunitsummary="locationUnitData"
        :locationunitsummarychartoptions="locationUnitDataChartOptions"
        :takeuppercentage="takeUpPercentage"
        :activeserviceaccounts="activeServiceAccounts.length"
        :passiveinstallscompleted="passiveInstallsComplete.length"
        :activeinstallscompleted="activeInstallsComplete.length"
        @locationnetworksummarypage="fetchLocationNetworksLocations()"
      ></locationnetworksummarypage>
    </div> -->

    <div v-if="displayContents('addressInformation')">
      <addressinfo
      :key="refresh"
      :customers="customers"
      :subcomplexes="allSubComplexes"
        :addressinfo="locationNetworkSummaryPage"
        :locationnodes="locationNodes"
        :regions="Regions"
        :networkfibrefarmers="fibreFarmers"
        :allfibrefarmers="customers"
        @addressinfo="fetchLocationNetworkSummaryPage()"
        @fibreFarmerSettingsUpdated="getFibreFarmersOnNetwork()"
        @subComplexUpdate="getSubComplexes()"
      ></addressinfo>
    </div>

    <div @click="getPackages()" v-if="displayContents('ispPackages')">
      <packagesisplocationnetworks
      :key="Isps"
        :packagesisplocationnetworks="packageIspLocationNetworks"
        :speedprofiles="speedProfiles"
        :packagesfnocat="packagesFnoCat"
        :customers="chosenIsps"
        :isps="Isps"
        :networkhasfnopackages="networkHasFnoPackages"
        :fnopackages="locationPackagesFno"
        :packagetypes="['Residential', 'Business','Other']"
        @ispPackageAdded="fetchPackagesIspLocationNetworks(), fetchCustomers()"
        @packagesisplocationnetworks="fetchPackagesIspLocationNetworks()"
      ></packagesisplocationnetworks>
    </div>

    <div v-if="displayContents('fnoPackages')">
      <packagesfnolocationnetworks
        :packagesfnolocationnetworks="packagesFnoLocationNetworks"
        :allpackagesfnolocationnetworks="allPackagesFnoLocationNetworks"
        :packagesfnocat="packagesFnoCat"
        :packagetypes="['Residential', 'Business','Other']"
        :speedprofiles="speedProfiles"
        :speedprofile="speedProfiles"
        :packagesfnocats="packagesFnoCats"
        @packagesFnoSaved="fetchPackagesFnoLocationNetworks()"
        @ispPackageAdded="fetchPackagesIspLocationNetworks(), fetchCustomers()"
      ></packagesfnolocationnetworks>
    </div>

    <div v-if="displayContents('locationNetworksLocations')">
         <v-toolbar flat color="white" class= "pt-3">
      <v-btn
        color="primary"
        dark
        class="mb-2"
        @click="addItem()"
        round
      >Add Unit</v-btn>
      <v-spacer></v-spacer>
        <v-text-field
        clearable
          label="Search"
          v-model="search"
          v-on:keyup.enter="$router.push({name: $route.name, 
          query:{offset: $route.query.offset, records: $route.query.records, search: search}})"
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="locationHeaders"
        class="elevation-1"
        :items="locationNetworksLocations"
        :rows-per-page-items="[$route.query.records]"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.locationDescription}}</td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.fibrePulled"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.equipmentInstalled"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.unitNo}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.erfNo}}</td>

        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.otherNo}}</td>
        <td v-if="props.item.locationNetworkSubComplexId!==null && props.item.locationNetworkSubComplex"
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.locationNetworkSubComplex.subComplexName}}</td>
        <td v-else
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        ></td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.complexStreetName}}</td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.complexName}}</td>
        <td @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.isActive===true"
        >
          <v-chip small :class="`Active white--text caption my-2`">Active</v-chip>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-chip small :class="`Inactive white--text caption my-2`">Inactive</v-chip>
        </td>
        </template>
    </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.offset">
        <v-pagination
          v-model="locationPage"
          :length="Math.ceil(locationLength/$route.query.records)"
          :total-visible="7"
        ></v-pagination>
      </div>
     <v-dialog persistent v-model="newUnitDialog" max-width="900px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Unit</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs  div="tabs">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab @click="addressInformation=true; installation=false; showDevices=false">Address Information</v-tab>
          <!-- <v-tab @click="addressInformation=false; showScheduleForm=true;showDevices=false">Installation Information</v-tab>
          <v-tab @click="addressInformation=false; installation=false; showDevices=true">Devices</v-tab> -->
          </v-tabs>
      </v-toolbar>

      <v-card flat xs12 sm6 md4 v-show="addressInformation">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="allSubComplexes"
                item-text="subComplexName"
                item-value="id"
                label="Associated Sub Complex"
                v-model="editedItem.locationNetworkSubComplexId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.locationDescription"
                  label="Location Description"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationTypeId"
                  label="*Location Type"
                  persistent-hint
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.erfNo" label="Erf No" 
                type="number"
                persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.unitNo" label="*Unit No" required persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.otherNo"
                  label="Other No"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.floorNo" label="Floor No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.subComplexName"
                  label="Sub Complex Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexStreetName"
                  label="Complex Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexName"
                  label="*Complex Name"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-switch v-model="editedItem.isActive" label="Active"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        <v-layout justfy-end>
          <v-btn color="primary" round @click="close">Cancel</v-btn>
        <v-btn color="primary" round @click="saveNewUnit">Save</v-btn>

        </v-layout>
        
      </v-card-actions>
      </v-card>

      
    </v-dialog>
     <!-- Edit Unit Modal -->
    <v-dialog persistent v-model="editUnitDialog" max-width="900px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Edit Unit</h1>
      </v-toolbar>
      <v-card flat>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="allSubComplexes"
                item-text="subComplexName"
                item-value="id"
                label="Associated Sub Complex"
                v-model="editedItem.locationNetworkSubComplexId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.locationDescription"
                  label="Location Description"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationTypeId"
                  label="*Location Type"
                  persistent-hint
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.erfNo" label="Erf No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.unitNo" label="*Unit No" required persistent-hint></v-text-field>

              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.otherNo"
                  label="Other No"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.floorNo" label="Floor No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexStreetName"
                  label="Complex Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexName"
                  label="*Complex Name"

                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-switch v-model="editedItem.isActive" label="Active"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>

          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="saveEditLocation">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

 <div v-if="displayContents('products')">
         <v-toolbar flat color="white" class= "pt-3">
      <v-btn
        color="primary"
        dark
        class="mb-2"
        @click="addProduct()"
        round
      >Add Product</v-btn>
      <v-spacer></v-spacer>
        <v-text-field
          clearable
          append-icon="search"
          label="Search"
          v-model="search"
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="productHeaders"
        class="elevation-1"
        :items="locationNetworkProducts"
        :search="search"
        item-key="id"
        align-center
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="justify-center layout px-0">
          <v-icon small @click="deleteProduct(props.item)">delete</v-icon>
        </td>
        <td  class="text-xs-center" v-if="props.item.stockItem">{{props.item.stockItem.name}}</td>
        <td  class="text-xs-center" v-else-if="props.item.deviceMakeModel">{{props.item.deviceMakeModel.name}}</td>
        <td  class="text-xs-center" v-if="props.item.stockItem">{{props.item.stockItem.stockType.name}}</td>
        <td  class="text-xs-center" v-else-if="props.item.deviceMakeModel">{{props.item.deviceMakeModel.deviceMake.name}}</td>
        <td v-if="props.item.stockItem&&props.item.stockItem.isSaleable" class="text-xs-center">{{(props.item.stockItem.priceExclVat)*(1+$VAT)|currency}}</td>
        <td v-else-if="props.item.deviceMakeModel&&props.item.deviceMakeModel.sellable" class="text-xs-center">{{props.item.deviceMakeModel.priceInclVat|currency}}</td>
        <td v-else class="text-xs-center"></td>
        </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

     <v-dialog persistent v-model="newProductDialog" max-width="900px">
      <v-toolbar color="primary" flat >
        <h1 class="headline white--text">Add Product</h1>
      </v-toolbar>
      <v-card flat xs12 sm6 md4 >
        <v-card-text>
          <v-layout wrap justify-center>
            <v-flex xs3 mx-1>
              <v-autocomplete ref="type" v-on:blur="$refs['type'].blur()" label="Product Type" :items="['Active', 'Passive']" v-model="product.type"></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-1>
              <v-autocomplete ref="deviceTypes" v-on:blur="$refs['deviceTypes'].blur()" v-if="product.type=='Active'" label="Category" item-text="name" :items="deviceTypes" return-object v-model="product.category" @change="getSellableDevices()"></v-autocomplete>
              <v-autocomplete ref="stockTypes" v-on:blur="$refs['stockTypes'].blur()" v-else-if="product.type=='Passive'" label="Category" item-text="name" :items="stockTypes" return-object v-model="product.category" @change="getStockItems()"></v-autocomplete>
            </v-flex>
          </v-layout>
          
          
          <div v-if="product.type=='Passive'&&product.category&&product.category.id">
            <v-toolbar flat color="white" class= "pt-3">
          <v-spacer></v-spacer>
             <v-text-field
        clearable
        append-icon="search"
          label="Search"
          v-model="searchProductModal"
        ></v-text-field>
          </v-toolbar>
            <v-data-table
      :headers="addPassiveProductHeaders"
      class="elevation-1"
      :items="allProducts"
      :search="searchProductModal"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td v-if="props.item.priceExclVat" class="text-xs-center">
            <v-icon color="primary" @click="selectProduct(props.item.id)">add_circle_outline</v-icon>
        </td>
        <td v-else class="text-xs-center">
            <v-btn small round color="primary" @click="editPriceItem(props.item)">Add Price</v-btn>
        </td>
        <td  class="text-xs-center">{{props.item.name}}</td>
        <td  class="text-xs-center">{{props.item.stockType.name}}</td>
        <td v-if="props.item.isSaleable" class="text-xs-center">{{(props.item.priceExclVat)*(1+$VAT)|currency}}</td>
        <td v-else class="text-xs-center"></td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
          </div>

          <div v-if="product.type=='Active'&&product.category&&product.category.id">
            <v-toolbar flat color="white" class= "pt-3">
          <v-spacer></v-spacer>
             <v-text-field
        clearable
        append-icon="search"
          label="Search"
          v-model="searchProductModal"
        ></v-text-field>
          </v-toolbar>
            <v-data-table
      :headers="addActiveProductHeaders"
      class="elevation-1"
      :items="allProducts"
      :search="searchProductModal"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td v-if="props.item.priceInclVat" class="text-xs-center">
            <v-icon color="primary" @click="selectProduct(props.item.id)">add_circle_outline</v-icon>
        </td>
        <td v-else class="text-xs-center">
            <v-btn small round color="primary" @click="editPriceItem(props.item)">Add Price</v-btn>
        </td>
        <td  class="text-xs-center">{{props.item.name}}</td>
        <td  class="text-xs-center">{{props.item.deviceMake.name}}</td>
        <td v-if="props.item.sellable" class="text-xs-center">{{props.item.priceInclVat|currency}}</td>
        <td v-else class="text-xs-center"></td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
          </div>
          
        </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
        <v-layout justfy-end>
          <v-btn color="primary" round @click="close">Cancel</v-btn>
        </v-layout>        
      </v-card-actions>
      </v-card>      
    </v-dialog>
    </div>





    <!-- <div v-if="displayContents('devices')">
      <devicecrud :devices="networkDevices" @devicesSaved="fetchDevices()"></devicecrud>
    </div> -->
    <div v-if="displayContents('networkDevices')">
      <!-- <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn round color="primary">Add Device to Network</v-btn>
      </v-toolbar> -->
      <!-- <devicecrud :key="deviceKey" :totalitems="devicesLength"
      :isloading="isLoading" :devices="networkDevices" @devicesSaved="fetchDevices()"></devicecrud> -->
      <!-- Device Modal -->
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
          label="Search"
          v-model="search"
          v-on:keyup.enter="$router.push({name: $route.name, query:{offset: '0', records: $route.query.records, search: search}})"
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="deviceHeaders"
        class="elevation-1"
        :items="allDevices"
        :rows-per-page-items="[20, 50, 100, 250]"
        :pagination.sync="pagination"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <!-- <td>
            <v-layout justify-center>
              <v-icon @click="deleteDevice(props.item)">delete</v-icon>
            </v-layout>
          </td> -->
          <td class="text-xs-center" @click="viewDeviceDetails(props.item)">{{props.item.systemName}}</td>
          <td
           @click="viewDeviceDetails(props.item)"
            v-if="props.item.locationId != null && props.item.location && typeof props.item.location != 'undefined'"
            class="text-xs-center"
          >{{props.item.location.locationDescription}}</td>
          <td  @click="viewDeviceDetails(props.item)" v-else class="text-xs-center"></td>
          <td
           @click="viewDeviceDetails(props.item)"
            v-if="props.item.locationNetwork"
            class="text-xs-center"
          >{{props.item.locationNetwork.name}}</td>
          <td  @click="viewDeviceDetails(props.item)" v-else class="text-xs-center"></td>
          <td  @click="viewDeviceDetails(props.item)" v-if="props.item.locationNode" class="text-xs-center">{{props.item.locationNode.name}}</td>
          <td  @click="viewDeviceDetails(props.item)" v-else class="text-xs-center"></td>
          <td  @click="viewDeviceDetails(props.item)"
            v-if="props.item.switchingCentre"
            class="text-xs-center"
          >{{props.item.switchingCentre.name}}</td>
          <td  @click="viewDeviceDetails(props.item)" v-else class="text-xs-center"></td>
          <!-- <td class="text-xs-center" v-else></td> -->
          <td
           @click="viewDeviceDetails(props.item)"
            class="text-xs-center"
            v-if="props.item.deviceMakeModelId!==null"
          >{{props.item.deviceMakeModel.deviceMake.name}}</td>
          <td  @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
          <td  @click="viewDeviceDetails(props.item)"
            class="text-xs-center"
            v-if="props.item.deviceMakeModelId!==null"
          >{{props.item.deviceMakeModel.deviceType.name}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
          <td @click="viewDeviceDetails(props.item)"
            class="text-xs-center"
            v-if="props.item.deviceMakeModelId!==null"
          >{{props.item.deviceMakeModel.name}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ipAddress}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.serialNumber}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponMac}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.macAddress}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponNumerical}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.productNumber}}</td>
          <td @click="viewDeviceDetails(props.item)"
            class="text-xs-center"
            v-if="props.item.upstreamDeviceId!=null && props.item.upstreamDevice!= null&&typeof(props.item.upstreamDevice) != 'undefined'"
          >{{props.item.upstreamDevice.deviceMakeModel.name}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponAddress}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponId}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.frame}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.slot}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.port}}</td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.note}}</td>

          <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-if="props.item.isActive">
            <v-icon color="green">done</v-icon>
          </td>
          <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
        </template>

        <!-- Custom Row count and Paging text -->
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.offset">
        <v-pagination
          v-model="page"
          :length="Math.ceil(devicesLength/pagination.rowsPerPage)"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>

    <div v-if="displayContents('financialOverview')">
      <financialoverview
        :partners="Partners"
        :locations="locationNetworksLocations"
        :transactions="networkTransactions"
        :totalunits="locationNetworksLocations.length"
        :completedpassiveinstalls="passiveInstallsComplete.length"
        :completedactiveinstalls="activeInstallsComplete.length"
        :unitspassed="locationNetworksLocations.length"
        :unitsconnected="locationNetworksLocations.length-passiveInstallsComplete.length"
        :unitslive="activeServiceAccounts.length"
      ></financialoverview>
    </div>
    <div v-if="displayContents('recurringTransactions')">
      <v-toolbar flat color="white">
      <v-btn round color="primary" @click="addRecurringItem()">Add Recurring Transaction</v-btn>
      
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      disable-initial-sort
      :headers="headers"
      :items="recurringTransactions"
      item-key="id"
      :rows-per-page-items="[10, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small @click="editRecurringItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteRecurringItem(props.item)">delete</v-icon>
        </td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.xeroCode}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.transactionType==='Loan'"
        >{{props.item.transactionType}}: {{props.item.loanAccountCustomer.name}}</td>
        <td class="text-xs-center" v-else>{{props.item.transactionType}}</td>
        <td class="text-xs-center" v-if="props.item.customerOrganisationId!==null">{{props.item.customerOrganisation.name}}</td>
        <td class="text-xs-center" v-else-if="props.item.supplierOrganisationId!==null">{{props.item.supplierOrganisation.name}}</td>
        <td class="text-xs-center" v-else></td>
        <td
          class="text-xs-center red--text"
          v-if="props.item.transactionType!=='Sales'&&props.item.transactionType!=='Loan'"
        >{{props.item.amount | currency}}</td>
        <td
          class="text-xs-center green--text"
          v-else-if="props.item.transactionType==='Sales'||props.item.transactionType==='Loan'"
        >{{props.item.amount | currency}}</td>
      </template>
    </v-data-table>
    </div>
    <div v-if="displayContents('transactions')">
      <transactions
        :locationid="null"
        :switchingcentreid="locationNetworkSummaryPage.locationNode.switchingCentreId"
        :locationnodeid="locationNetworkSummaryPage.locationNodeId"
        :locationnetworkid="this.$route.params.locationNetworkId"
        :transactions="networkTransactions"
        :partners="Partners"
        :descriptionlist="descriptionList"
        :salesvalue="salesValue"
        :cosvalue="cosValue"
        :expensevalue="expenseValue"
        :loanvalue="loanValue"
        :isloading="isLoading"
        @refreshTotals="sum()"
        @transactionAdded="getTransactions()"
      ></transactions>
    </div>
    <div v-if="displayContents('documents')">
      <documentcomponent :locationnetworkid="this.$route.params.locationNetworkId" :documents="locationNetworkDocuments" @documentChange="fetchDocuments"></documentcomponent>
    </div>


    <v-dialog persistent v-model="addTransactionModal" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD RECURRING TRANSACTION</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Type"
                  :items="transactionTypes"
                  v-model="recurringTransactionItem.transactionType"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select Contributor"
                  :items="partners"
                  item-text="name"
                  item-value="id"
                  v-model="recurringTransactionItem.loanAccountCustomerId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="salesTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Cost of Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="cosTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Expense'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="expenseTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="loanTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Customer"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.customerOrganisationId"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-else-if="recurringTransactionItem.transactionType===('Cost of Sales'||'Expense')">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Supplier"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.supplierOrganisationId"
               >
               </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.amount" label="*Amount"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="addTransactionModal=false, recurringTransactionItem={}">Cancel</v-btn>
          <v-btn color="primary" round @click="saveNewRecurringTransaction">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editTransactionModal" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT RECURRING TRANSACTION</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Type"
                  :items="transactionTypes"
                  v-model="recurringTransactionItem.transactionType"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select Contributor"
                  :items="partners"
                  item-text="name"
                  item-value="id"
                  v-model="recurringTransactionItem.loanAccountCustomerId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="salesTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Cost of Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="cosTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Expense'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="expenseTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="loanTransactionCategories"
                  v-model="recurringTransactionItem.description"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Customer"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.customerOrganisationId"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-else-if="recurringTransactionItem.transactionType===('Cost of Sales'||'Expense')">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Supplier"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.supplierOrganisationId"
               >
               </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.amount" label="*Amount"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="editTransactionModal=false, recurringTransactionItem={}">Cancel</v-btn>
          <v-btn color="primary" round @click="saveRecurringTransaction">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

 <v-dialog persistent v-model="editPriceDialog" max-width="400px">
        <v-toolbar color="primary">
          <h1 class="headline white--text">EDIT PRODUCT PRICE</h1>
        </v-toolbar>
       <v-card flat>
           <v-card-text>
          <v-layout>
        <v-flex xs12 mx-1>
        <v-text-field label="Price (excl. VAT)" type="number" v-model="editPrice.priceExclVat"></v-text-field>
        </v-flex>
          </v-layout>
        
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="editPriceDialog=false, editPrice={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="editPrice.priceExclVat" @click="addPrice()">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import LocationNetworksLocations from "@/components/Locations/LocationNetworksLocations.vue";
import CustomerImport from "@/components/Locations/CustomerImport.vue";
import NmsSync from "@/components/Locations/NmsSync.vue";
import PackagesFnoLocationNetworks from "@/components/Locations/LocationFnoPackages.vue";
import LocationNetworkSummaryPage from "@/components/Locations/SummaryPage.vue";
import AddressInfo from "@/components/Locations/AddressInfo.vue";
import PackagesIspLocationNetworks from "@/components/Locations/LocationIspPackages.vue";
import LocationUnitSummary from "@/components/Locations/SummaryPage.vue";
import LocationUnitSummaryChartOptions from "@/components/Locations/SummaryPage.vue";
import TakeUpPercentage from "@/components/Locations/SummaryPage.vue";
import Devices from "@/components/DeviceCrud.vue";
import TreeView from "@/components/TreeView.vue";
import Transactions from "@/components/Transactions.vue";
import FinancialOverview from "@/components/FinancialOverview.vue";
import Loading from 'vue-loading-overlay';
import DocumentUpload from '@/components/Documents.vue';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  props: ["locationnetworksummary"],
  components: {
    locationnetworkslocations: LocationNetworksLocations,
    customerimport: CustomerImport,
    nmssync: NmsSync,
    packagesfnolocationnetworks: PackagesFnoLocationNetworks,
    locationnetworksummarypage: LocationNetworkSummaryPage,
    addressinfo: AddressInfo,
    packagesisplocationnetworks: PackagesIspLocationNetworks,
    // locationunitsummary: LocationUnitSummary,
    // locationunitsummarychartoptions: LocationUnitSummaryChartOptions,
    // takeuppercentage: TakeUpPercentage,
    // devicecrud: Devices,
    // deviceTree: TreeView,
    transactions: Transactions,
    financialoverview: FinancialOverview,
    loading: Loading,
    documentcomponent: DocumentUpload
  },
  data() {
    return {
      editPriceDialog:false,
      editPrice:{},
      allProducts:[],
      stockTypes: [],
      deviceTypes: [],
      product: {
        type: 'Active',
        category: null,
        id: null
      },
      addPassiveProductHeaders:[
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Type",
          align: "center",
          value: "stockType.name"
        },
        {
          text: "Price Incl. VAT",
          align: "center",
          value: "priceExclVat"
        }
      ],
       addActiveProductHeaders:[
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Type",
          align: "center",
          value: "stockType.name"
        },
        {
          text: "Price Incl. VAT",
          align: "center",
          value: "priceInclVat"
        }
      ],
      productHeaders:[
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "stockItem.name"
        },
        {
          text: "Stock Type",
          align: "center",
          value: "stockItem.stockType.name"
        },
        {
          text: "Price Incl. VAT",
          align: "center",
          value: "stockItem.priceExclVat"
        }
      ],
      locationNetworkProducts:[],
      newProductDialog: false,
      editProductDialog: false,
      unitsPassedNetworkSummary:null,
      locationTypes:[],
      selectedAccessPointGroups: [],
      accessPointGroupSearch: false,  
      newUnitDialog: false,
      accessPointGroups: [],
      Regions: [],
      editedItem: {
        accessPointGroupId: null,
        locationNetworkSubComplexId: null,
        prefix: "",
        suffix: "",
        unitStart: "",
        unitEnd: "",
        locationDescription: "",
        locationTypeId: null,
        erfNo: null,
        otherNo: "",
        unitNo: "",
        floorNo: null,
        complexStreetName: "",
        complexName: "",
        subComplexName: "",
        fibrePulled: "",
        equipmentInstalled: "",
        locationNetworkId: null,
        isActive: true
      },
       locationNetworksLocations:[],
       locationPage:1,
       locationPagination: {},
       locationLength: 0,
       locationHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Description",
          align: "center",
          value: "locationDescription"
        },
        {
          text: "Passive Install Complete",
          align: "center",
          value: "fibrePulled"
        },
        {
          text: "Active Install Complete",
          align: "center",
          value: "equipmentInstalled"
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo"
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo"
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo"
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subComplexName"
        },
        {
          text: "Street Name",
          align: "center",
          value: "streetName"
        },
        {
          text: "Complex Name",
          align: "center",
          value: "complexName"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        }
      ],
      chosenIspLists:[],
      editTransactionModal: false,
      addTransactionModal: false,
      loadingNetwork: false,
      activeTabName: null,
      pageLoaded: false,
      chosenIspsArray: [],
      chosenIsps: [],
      Partners: [],
      allCustomers:[],
      recurringTransactions: [],
      locationNetworkDocuments:[],
      Isps: [],
      page: 1,
      descriptionList: [],
      activeServiceAccounts: [],
      networkHasFnoPackages: false,
      isLoading: true,
      packagesFnoCats: [],
      fibreFarmers: [],
      chosenFnoCats: [],
      deviceSearch: null,
      packageFnoCatsArrays: [],
      showDetails: true,
      Customers: [],
      networkTransactions: [],
      speedProfilesArray: [],
      loading: false,
      expand: false,
      searchProductModal:"",
      search: "",
      dialog: false,
      locationPackagesFno: [],
      pagination: {},
      networkServiceAccounts: [],
      allPackagesFnoLocationNetworks: [],
      speedProfiles: [],
      locationNetworkSummaryPage: {},
      allSubComplexes:[],
      customers: [],
      packagesFnoCat: [],
      locationNodes: [],
      locationUnitData: null,
      takeUpPercentage: null,
      locationUnitDataChartOptions: null,
      packagesFnoLocationNetworks: [],
      nodeDevices: [],
      networkDevices: [],
      packageIspLocationNetworks: [],
      totals: [],
      salesValue: 0,
      cosValue: 0,
      expenseValue: 0,
      loanValue: 0,
      locationsLength: 0,
      locationKey: 0,
      allDevices: [],
      passiveInstallsComplete: [],
      activeInstallsComplete: [],
      onceoffDataIncome: [],
      onceoffDataCosts: [],
      recurringDataIncome: [],
      recurringDataCosts: [],
      devicesLength: 0,
      refresh:0,
      transactionTypes: ["Sales", "Cost of Sales", "Expense", "Loan"],
      salesTransactionCategories: [
        "Router Installation",
        "Data Activation Fee",
        "Internet Package",
        "Layer 2",
        "Layer 3",
        "SLA"
      ],
      cosTransactionCategories: ["Labour", "Network Management Fee", "Layer 2", "Layer 3"],
      expenseTransactionCategories: ["Hardware", "Labour", "Other"],
      loanTransactionCategories: [
        "Active Equipment",
        "Passive Equipment",
        "Civils",
        "Other"
      ],
      buildStatus: ["Planned", "Ongoing", "Complete"],
      fibreHeadendInstallStatus: ["Planned", "Ongoing", "Live"],
      tabs: [
        // { name: 'locationNetworkSummary', displayName: 'Network Summary'},
        { name: "addressInformation", displayName: "Network Information" },
        {
          name: "locationNetworksLocations",
          displayName: "Associated Locations"
        },
        { name: "fnoPackages", displayName: "FNO Packages" },
        { name: "ispPackages", displayName: "ISP's" },
        { name: "networkDevices", displayName: "Network Devices" },
        // { name: "installations", displayName: "Installations" },
        // { name: "financialOverview", displayName: "Financial Overview" },
        { name: "recurringTransactions", displayName: "Recurring Transactions" },
        { name: "transactions", displayName: "Transactions" },
        { name: "products", displayName: "Products" },
        {name: "documents", displayName: "Documents"}
       
        // { name: "devices", displayName: "Devices" }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Xero Code",
          align: "center",
          value: "xeroCode"
        },
        {
          text: "Transaction Type",
          align: "center",
          value: "transactionType"
        },
        {
          text: "Customer/Supplier",
          align: "center",
          value: "customerOrganisation.name"
        },
        {
          text: "Amount",
          align: "center",
          value: "amount"
        }
      ],
      recurringTransactionItem: {},
      devicesTree: [],
      editedIndex: -1,
      editedItem: {
        packagesFnoLocationNetworks: "",
        name: "",
        lineRentalIncluded: "",
        tvOverFibre: "",
        gtuIncluded: "",
        activationFee: "",
        routerInstallationFee: "",
        residentialLineRentalValue: "",
        businessLineRentalValue: "",
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        name: "",
        isActive: true,
        isDeleted: ""
      },
      subNetwork: {
        id: "",
        name: ""
      },
      deviceHeaders: [
        // {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "System Name",
          align: "center",
          value: "systemName"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Switching Centre",
          align: "center",
          value: "switchingCentre.name"
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name"
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name"
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac"
        },
        {
          text: "Mac Address",
          align: "center",
          value: "macAddress"
        },
        {
          text: "Pon Numerical",
          align: "center",
          value: "ponNumerical"
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber"
        },

        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.deviceMakeModel.name"
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress"
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId"
        },
        {
          text: "Frame",
          align: "center",
          value: "frame"
        },
        {
          text: "Slot",
          align: "center",
          value: "slot"
        },
        {
          text: "Port",
          align: "center",
          value: "port"
        },
        {
          text: "Note",
          align: "center",
          value: "note"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        }
      ]
    };
  },
  async mounted() {
    this.setActiveTabName("addressInformation");
    this.pageLoaded = false;
    setTimeout(()=>{
       this.loadingNetwork=false
    },3000)

    // try {
      // await Api()
      //   .get("/locationNetworks/" + this.$route.params.locationNetworkId)
      //   .then(response => {
      //     this.locationNetworksLocations = response.data.locations;
      //   });
    //   await Api()
    //     .get(
    //       "/serviceaccounts/allActiveByNetwork/" +
    //         this.$route.params.locationNetworkId
    //     )
    //     .then(response => {
    //       this.networkServiceAccounts = response.data;
    //     });
    //   (this.locationUnitData = {
    //     labels: ["Current Unit Stats"],
    //     datasets: [
    //       {
    //         label: "Live Connections",
    //         data: [this.activeServiceAccounts.length],
    //         backgroundColor: ["rgba(75, 192, 192, 0.2)"],
    //         borderColor: ["rgba(75, 192, 192, 1)"],
    //         borderWidth: 1
    //       },
    //       {
    //         label: "Equipped Units",
    //         data: [this.activeInstallsComplete.length],
    //         backgroundColor: ["rgba(255, 99, 132, 0.2)"],
    //         borderColor: ["rgba(255, 99, 132, 1)"],
    //         borderWidth: 1
    //       },
    //       {
    //         label: "Connected Units",
    //         data: [this.passiveInstallsComplete.length],
    //         backgroundColor: ["rgba(54, 162, 235, 0.2)"],
    //         borderColor: ["rgba(54, 162, 235, 1)"],
    //         borderWidth: 1
    //       },
    //       {
    //         label: "Total Units",
    //         data: [this.locationNetworksLocations.length],
    //         backgroundColor: ["rgba(255, 206, 86, 0.2)"],
    //         borderColor: ["rgba(255, 206, 86, 1)"],
    //         borderWidth: 1
    //       }
    //     ]
    //   }),
    //     (this.takeUpPercentage = {
    //       labels: ["Live Connections", "Unsigned Units in Network"],
    //       datasets: [
    //         {
    //           label: "Active Units",
    //           data: [
    //             this.activeServiceAccounts.length,
    //             this.locationNetworksLocations.length -
    //               this.activeServiceAccounts.length
    //           ],
    //           backgroundColor: [
    //             "rgba(75, 192, 192, 0.2)",
    //             "rgba(255, 99, 132, 0.2)"
    //           ],
    //           borderColor: ["rgba(75, 192, 192, 1)", "rgba(255, 99, 132, 1)"],
    //           borderWidth: 1
    //         }
    //       ]
    //     }),
    //     (this.locationUnitDataChartOptions = {
    //       title: {
    //         display: true,
    //         text: "Network Unit Summary"
    //       },
    //       tooltip: {
    //         enabled: true
    //       },
    //       scales: {
    //         yAxes: [
    //           {
    //             ticks: {
    //               beginAtZero: true
    //             }
    //           }
    //         ]
    //       }
    //     }),
    //     (this.pageLoaded = true);
           
    // this.loadingNetwork=false
    // } catch (e) {}
  },

  computed: {
    formattedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    '$route.params.locationNetworkId': {
          immediate: true,
          handler(value){
                 this.initialize()
          }
      },
        "$route.query.search": {
      immediate: true,
      handler(value) {
        // this.devices= await this.search(value.search)
        if(this.displayContents('networkDevices')){
           this.isLoading = true;
        if (this.$route.query.search && value !== "" && value != null) {
          // debugger
          Api()
            .get("/devices/active/network/"+this.$route.params.locationNetworkId, {
              params: {
                search: value,
                offset: this.$route.query.offset,
                records: this.$route.query.records
              }
            })
            .then(response => { 
              this.allDevices=response.data.result
              this.devicesLength=response.data.count
              this.pagination.totalItems=this.devicesLength
              this.isLoading = false;
            });
        } else if (this.$route.query.offset && this.$route.query.records) {
          // debugger
          Api()
            .get("/devices/active/network/"+this.$route.params.locationNetworkId, {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records
              }
            })
            .then(response => {
              this.allDevices=response.data.result
              this.devicesLength=response.data.count
              this.pagination.totalItems=this.devicesLength
              this.isLoading = false;
            });
          // this.fetchDevices()
          // // debugger
        }
      } else if(this.displayContents('locationNetworksLocations')){
      if(this.$route.query.search&&value!==""&&value != null){   
        this.locationPage = 1   
        // debugger
        Api()
        .get('/locations/byNetwork/'+this.$route.params.locationNetworkId+'/activeFilter',{
          params: {
          search: value,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.locationNetworksLocations=response.data.result
          this.locationLength=response.data.count
          this.locationKey +=1
            this.loading=false
          })} else if(this.$route.query.offset){
            // debugger
             Api()
        .get('/locations/byNetwork/'+this.$route.params.locationNetworkId+'/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.locationNetworksLocations=response.data.result
          this.locationLength=response.data.count
          this.locationKey +=1
            this.loading=false})
            // this.fetchDevices()
            // // debugger
          }
      }}
       
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        // this.devices= await this.search(value.search)
        if(this.displayContents('networkDevices')){
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get("/devices/active/network/"+this.$route.params.locationNetworkId, {
              params: {
                search: this.$route.query.search,
                offset: this.$route.query.offset,
                records: this.$route.query.records
              }
            })
            .then(response => {
              this.devices = response.data;
              this.devicesLength = this.devices.length;
              this.pagination.totalItems=this.devicesLength
              this.isLoading = false;
              
            });
        } else if (value !== "" && value != null) {
          // debugger
          Api()
            .get("/devices/active/network/"+this.$route.params.locationNetworkId, {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records
              }
            })
            .then(response => {
              this.allDevices=response.data.result
              this.devicesLength=response.data.count
              this.pagination.totalItems=this.devicesLength
              this.isLoading = false;
            });
        }
      } 
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!="" &&this.$route.query.search!== null){      
        
        Api()
        .get('/locations/byNetwork/'+this.$route.params.locationNetworkId+'/activeFilter',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.locationNetworksLocations=response.data.result
          this.locationLength=response.data.count
          this.locationKey += 1
            this.isLoading=false})
      } else if(value!==""&&value != null){
        // debugger
         Api()
        .get('/locations/byNetwork/'+this.$route.params.locationNetworkId+'/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.locationNetworksLocations=response.data.result
          this.locationLength=response.data.count
          this.locationKey += 1
            this.isLoading=false})
      }
      
      }
      
    },
    page(value) {
        if(this.displayContents('networkDevices')){
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records
            }
          });
        }
      }
    }
    },
    locationPage(value) {
      this.locationPagination.page = this.locationPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records
            }
          });
        }
      }
    }
  },

  created() {
      this.$router.push({name: this.$route.name, query:{offset: '0', records: '20'}})
      this.fetchUnitsPassed()
      this.fetchDeviceType()
      this.fetchItemCategories()
    // this.initialize();  
  },

  methods: {
    fetchDeviceType(){
      Api().get('/deviceTypes').then(response=>{
      this.deviceTypes = response.data
      })
    },
    fetchItemCategories(){
      Api().get('/stockType').then(response=>{
      this.stockTypes = response.data
      })
    },
     editPriceItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editPrice = Object.assign({}, item);
      this.editPriceDialog = true;
      }
    },
    addPrice(){
       Api()
        .put("/stockItem/"+this.editPrice.id, {
          priceExclVat: this.editPrice.priceExclVat,
          isSaleable: true
        }).then(response=>{
          this.getStockItems()
          this.editPriceDialog=false
          this.editPrice={}
        })
    },
    selectProduct(id){
  Api().post('/locationNetworkProduct',{
    locationNetworkId: this.$route.params.locationNetworkId,
    stockItemId: this.product.type=='Passive'?id:null,
    deviceMakeModelId: this.product.type=='Active'?id:null,
    isActive:true,
    isDeleted:false
  }).then(response=>{
    this.fetchProducts()
    this.newProductDialog=false
    })
    },
     getStockItems(){
        Api()
        .get("/saleable/stockItem/"+this.product.category.id)
        .then(response => {
          this.allProducts = response.data;
        });
    },
    getSellableDevices(){
      Api()
        .get("/saleable/devices/"+this.product.category.id)
        .then(response => {
          this.allProducts = response.data;
        });
    },
    deleteProduct (item){
      if(this.authDelete(this.$store.state.currentRoute)){
        confirm('Are you sure you want to delete this product?')&&
        Api()
        .put('/locationNetworkProduct/'+item.id,{
          isActive: false,
          isDeleted: true
        }).then(response=>{
          let index = this.locationNetworkProducts.indexOf(item)
          this.locationNetworkProducts.splice(index, 1)
        })
      }
    },
    addProduct(){
      if(this.authCreate(this.$store.state.currentRoute)){
      this.newProductDialog=true
      }
    },
    fetchUnitsPassed(){
   Api().get('/locations/countbyNetwork/'+this.$route.params.locationNetworkId).then(response=>{
     this.unitsPassedNetworkSummary = response.data
   })
    },
    getlocationTypes() {
      Api()
        .get("/locationTypes")
        .then(response => {
          this.locationTypes = response.data;
        });
    },
    addItem(){
      this.newUnitDialog=true,this.addressInformation=true;this.clearFields()      
    },
      close() {
      this.dialog = false;
      this.newUnitDialog = false;
      this.newProductDialog = false;
      this.editProductDialog = false;

      this.editUnitDialog = false;
      this.generateUnits = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
        clearFields() {
        this.selectedAccessPointGroups =[],
        this.editedItem.unitStart = "",
        this.editedItem.unitEnd = "",
        this.editedItem.locationDescription = "",
        this.editedItem.locationTypeId = null,
        this.editedItemerfNo = null,
        this.editedItem.otherNo = "",
        this.editedItem.unitNo = "",
        this.editedItem.floorNo = null,
        this.editedItem.complexStreetName = "",
        this.editedItem.complexName = "",
        this.editedItem.subComplexName = "",
        this.editedItem.fibrePulled = "",
        this.editedItem.equipmentInstalled = "",
        this.editedItem.locationNetworkId = null
    },
    viewDeviceDetails(item){
      // this.$router.push('http://acs.fibregeeks.co.za/live/AXCustomerSupportPortal/#/cpe/cpeid/'+item.ponMac+'?hide_header=1&tab=CpeOverview');
      this.$router.push({ path: "/devices/" + item.id });
    },
    async deviceCount(){
      Api()
      .get('/devices/active/networkCount/'+this.$route.params.locationNetworkId)
      .then(response=>{
          this.devicesLength = response.data.count;
          this.pagination.totalItems=this.devicesLength
      })
    },
    fetchDocuments(){
      Api()
      .get('/upload/byNetwork/'+this.$route.params.locationNetworkId)
      .then(response=>{
        this.locationNetworkDocuments=response.data
      })
    },
    getSubComplexes(){
      Api()
      .get('/locationnetworksubcomplex/bynetwork/'+this.$route.params.locationNetworkId)
      .then(response=>{
        this.allSubComplexes=response.data
      })
    },
    getServiceaccounts() {
      Api()
        .get(
          "/serviceAccounts/allActiveByNetwork/" +
            this.$route.params.locationNetworkId
        )
        .then(response => {
          let activeServiceAccountsArray = response.data;
          this.totalServiceAccounts = [];
          this.activeServiceAccounts = activeServiceAccountsArray.filter(function (el) {
  return el.location !==null
});
      var res = {};

      this.activeServiceAccounts.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
        });
    },
    getTransactions() {
      this.isLoading=true
      this.descriptionList = [];
      Api()
        .get("/transactions/byNetwork/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.networkTransactions = response.data;
          for (let i = 0; i < this.networkTransactions.length; i++) {
            if (
              !this.descriptionList.includes(
                this.networkTransactions[i].description
              )
            ) {
              this.descriptionList.push(
                this.networkTransactions[i].description
              );
            }
          }
          this.sum();
          // this.transactionsByMonth();
          this.isLoading=false
        });
    },
    saveNewRecurringTransaction(){
      Api()
      .post('/locationNetworkrecurringTransactions',{
        locationNetworkId: this.$route.params.locationNetworkId,
        description: this.recurringTransactionItem.description,
        transactionType: this.recurringTransactionItem.transactionType,
        amount: this.recurringTransactionItem.amount,
        xeroCode: this.recurringTransactionItem.xeroCode,
        description: this.recurringTransactionItem.description,
        supplierOrganisationId: this.recurringTransactionItem.supplierOrganisationId,
        customerOrganisationId: this.recurringTransactionItem.customerOrganisationId,
        isActive: true,
        isDeleted: false
      }).then(this.getRecurringTransactions(), this.recurringTransactionItem={}, this.addTransactionModal=false)
    },
    saveRecurringTransaction(){
      Api()
      .put('/locationNetworkrecurringTransactions/'+this.recurringTransactionItem.id,{
        description: this.recurringTransactionItem.description,
        transactionType: this.recurringTransactionItem.transactionType,
        amount: this.recurringTransactionItem.amount,
        xeroCode: this.recurringTransactionItem.xeroCode,
        description: this.recurringTransactionItem.description,
        supplierOrganisationId: this.recurringTransactionItem.supplierOrganisationId,
        customerOrganisationId: this.recurringTransactionItem.customerOrganisationId,
        isActive: true,
        isDeleted: false
      }).then(this.getRecurringTransactions(), this.recurringTransactionItem={},this.editTransactionModal=false)
    },
    addRecurringItem (item){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.recurringTransactionItem = Object.assign({}, item);
        this.addTransactionModal=true
      }
    },
    editRecurringItem (item){
      if(this.authUpdate(this.$store.state.currentRoute)){
        this.recurringTransactionItem = Object.assign({}, item);
        this.editTransactionModal=true
      }
    },
    deleteRecurringItem (item){
      if(this.authDelete(this.$store.state.currentRoute)){
        this.recurringTransactionItem = Object.assign({}, item);
        confirm('Are you sure you want to delete this recurring transaction?')&&
        Api()
        .put('/locationNetworkRecurringTransactions/'+item.id,{
          isActive: false,
          isDeleted: true
        }).then(response=>{
          let index = this.recurringTransactions.indexOf(item)
          this.recurringTransactions.splice(index, 1)
        })
      }
    },
    getRecurringTransactions() {
      Api()
        .get("/locationNetworkRecurringTransactions/byNetwork/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.recurringTransactions = response.data;
        });
    },
    getNodeDevices() {
      if(typeof(this.editedItem.locationNodeId) != 'undefined')
      Api()
        .get("/devices/nodeLevelDevices/" + this.editedItem.locationNodeId)
        .then(response => {
          this.nodeDevices = response.data;
        });
    },
    // getNetworkDevices() {
    //   Api()
    //     .get(
    //       "/devices/networkLevelDevices/" + this.$route.params.locationNetworkId
    //     )
    //     .then(response => {
    //       this.networkDevices = response.data;
    //     });
    // },
    getFibreFarmersOnNetwork() {
      Api()
        .get(
          "/fibreFarmerLocationNetwork/byNetwork/" +
            this.$route.params.locationNetworkId
        )
        .then(response => {
          this.fibreFarmers = response.data;
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].isInvestor
            ) {
              this.Partners.push(this.$store.state.currentOrg.org)
              this.Partners.push(response.data[i].customerOrganisation);
            }
          }
        });
    },
    fetchAllPackageCategories() {
      Api()
        .get("/packagesFnoCats/active")
        .then(response => {
          this.packagesFnoCats = response.data;
        });
    },
    async getPackages() {
      this.chosenIspsArray = [];
      // this.chosenIsps = [];
      this.chosenFnoCats = [];
      this.packageFnoCatsArrays = [];
       await Api()
        .get(
          "/packagesFnoLocationNetwork/showByLocationNetwork/" +
            this.$route.params.locationNetworkId
        )
        .then(async response => {
          this.chosenFnoCats = [];
          this.packageFno = response.data;
          if (this.packageFno.length > 0) {
            this.fnoPackagesGenerated = true;
          } else {
            this.fnoPackagesGenerated = false;
          }

          this.packageFnoCatsArrays = [
            ...new Set(
              this.packageFno.map(
                item => item.packagesFno.packagesFnoCatId
              )
            )
          ];
          // for (var i = 0; i < this.packageFno.length; i++) {
          //   if (
          //     !this.packageFnoCatsArrays.includes(
          //       this.packageFno[i].packagesFno.packagesFnoCatId
          //     )
          //   ) {
          //     this.packageFnoCatsArrays.push(
          //       this.packageFno[i].packagesFno.packagesFnoCatId
          //     );
          //   }
          // }
          for (var y = 0; y < this.packageFnoCatsArrays.length; y++) {
              await Api()
              .get("/packagesFnoCats/" + this.packageFnoCatsArrays[y])
              .then(response => {
                this.chosenFnoCats.push({
                  name: response.data[0].name,
                  id: response.data[0].id
                });
              });
          }
          for (var i = 0; i < this.packageFno.length; i++) {
            if (this.chosenFnoCats.length !== 0) {
              for (var x = 0; x < this.chosenFnoCats.length; x++) {
                if (
                  !this.packageFnoCatsArrays.includes(
                    response.data[i].packagesFno.packagesFnoCat.id
                  )
                ) {
                  this.chosenFnoCats.push({
                    name: response.data[i].packagesFno.packagesFnoCat.name,
                    id: response.data[i].packagesFno.packagesFnoCat.id
                  });
                }
              }
            }
          }
        });
    },
    async fetchCustomers() {
      this.chosenIspsArray = [];
      let packages =[]
      let foreignKey = []
      await Api()
      .get('/supplier/ispLocationNetwork/byNetwork/'+this.$route.params.locationNetworkId)
      .then(async response=>{        
        // let ispIdArray=[]
        this.chosenIsps = [];
        let array = await response.data.filter(x=>new Date(x.packagesFno.startDate)< new Date()&&new Date(x.packagesFno.endDate)> new Date()&&x.isActive&&!x.isDeleted&&x.packagesFno.isActive&&!x.packagesFno.isDeleted)
        packages = await array.map(x=>({id: x.customerOrganisationId, fnoPackage: x.packagesFno}))
        foreignKey = array
        let ispIdArray = [
            ...new Set(
              response.data.map(
                item => item.customerOrganisation.id
              )
            )
          ];
        let IspArray = [
            ...new Set(
              response.data.map(
                item => item.customerOrganisation
              )
            )
          ]
          ispIdArray.forEach(x=>{
            let find = IspArray.find(y=>y.id === x)
            this.chosenIsps.push(find)
          })
        await this.chosenIsps.map(async z=>{
          z.packagesFno = await packages.filter(a=>a.id == z.id)
          z.ref = await foreignKey.filter(a=>a.customerOrganisationId == z.id)
          z.locationNetworkId = this.$route.params.locationNetworkId

        })
      })
      Api()
        .get("/organisation/subOrganisations/ISP")
        .then(async response => {
          this.Isps = response.data;
          this.Isps.unshift(this.$store.state.currentOrg.org)
          this.Isps = this.Isps.filter(x=>!this.chosenIsps.map(y=>y.id).includes(x.id))
          // for (let i=0; i< this.chosenIsps.length;i++){
          //   let index = this.Isps.map(function(e) { return e.id; }).indexOf(this.chosenIsps[i].id);
          //   this.Isps.splice(index, 1)
          // }
          
        });  
        Api()
        .get("/organisation/subOrganisations/all")
        .then(response => {
          this.customers = response.data;
        });     
    },
    fetchPackagesFnoTypes() {
      Api()
        .get("/packagesFnoCats/active")
        .then(response => {
          this.packagesFnoCat = response.data;
        });
    },
    async removeDuplicates(array) {
  return await array.filter((a, b) => array.indexOf(a) === b)
},
    fetchDevices() {
      // if (this.deviceSearch) {
      //   Api()
      //     .get("/devices/byNetwork/" + this.$route.params.locationNetworkId, {
      //       params: {
      //         search: this.deviceSearch
      //       }
      //     })
      //     .then(response => {
      //       this.networkDevices = response.data;
      //     });
      // } else {
      //   Api()
      //     .get("/devices/byNetwork/" + this.$route.params.locationNetworkId)
      //     .then(response => {
      //       this.networkDevices = response.data;
      //     });
      // }
    },
    fetchNetworkDevices() {
      // Api()
      //   .get(
      //     "/devices/networkLevelDevices/" + this.$route.params.locationNetworkId
      //   )
      //   .then(response => {});
    },
    fetchLocationNetworks() {
      Api()
        .get("/locationNetworks/active")
        .then(response => {
          this.locationNetworks = response.data;
        });
    },
    fetchLocationNodes() {
      Api()
        .get("/locationNodes/active")
        .then(response => {
          this.locationNodes = response.data;
        });
    },
    fetchRegions(){
      Api().get('/region').then(response=>{
        this.Regions=response.data
      })
    },
    async fetchLocationNetworksLocations() {
      await Api()
        .get("/locationNetworks/" + this.$route.params.locationNetworkId)
        .then(async response => {
            this.locationNetworksLocations = response.data.locations;
 await this.installsCalculation();
        });
    },
    async fetchLocationNetworkSummaryPage() {           
      this.loadingNetwork=true
      await Api()
        .get("/locationNetworks/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.locationNetworkSummaryPage = response.data;
          this.refresh++
        });
    },
    fetchSpeedProfiles() {
      Api()
        .get("/speedprofiles/active")
        .then(response => {
          this.speedProfiles = response.data;
        });
    },
    getAllFnoPackages() {
      Api()
        .get("/packagesFnos")
        .then(response => {
          this.packagesFno = response.data;
        });
    },
    async fetchPackagesIspLocationNetworks() {
      await Api()
        .get("/supplier/packagesIsps/byNetwork/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.packageIspLocationNetworks = response.data;
          for (let i = 0; i < response.data.length; i++) {
            if (
              !this.speedProfilesArray.includes(
                response.data[i].packagesFno.speedProfile.id
              )
            ) {
              this.speedProfilesArray.push(
                response.data[i].packagesFno.speedProfile.id
              );
              this.speedProfiles.push(
                response.data[i].packagesFno.speedProfile
              );
            }
          }
        });
    },
    async fetchPackagesFnoLocationNetworks() {
      
      await Api()
        .get(
          "/packagesFnoLocationNetwork/showByLocationNetwork/" +
            this.$route.params.locationNetworkId
        )
        .then(response => {
          this.locationPackagesFno=[]
          this.packagesFnoLocationNetworks = response.data;
          if (this.allPackagesFnoLocationNetworks.length > 0) {
            this.networkHasFnoPackages = true;
          }
          for (let i=0;i<response.data.length;i++){
            this.locationPackagesFno.push(response.data[i].packagesFno)
          }
          
        });
    },
    fetchAllPackagesFnoLocationNetworks() {
      Api()
        .get("/packagesFnos/active")
        .then(response => {
          this.allPackagesFnoLocationNetworks = response.data;
          if (this.allPackagesFnoLocationNetworks.length > 0) {
            this.networkHasFnoPackages = true;
          }
        });
    },

    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) { 
      this.activeTabName = name;
    },
    
    sum() {
      this.totals = [];
      this.salesValue = 0;
      this.cosValue = 0;
      this.expenseValue = 0;
      this.loanValue = 0;
      var res = {};

      this.networkTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      // for (let i=0; i< res.length;i++){

      // }
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
    },
    monthlyRecurring() {
      this.totals = [];
      this.salesValue = 0;
      this.cosValue = 0;
      this.expenseValue = 0;
      this.loanValue = 0;
      var res = {};

      this.networkTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
    },
    installsCalculation() {
      this.passiveInstallsComplete = this.locationNetworksLocations.filter(
        function(el) {
          return el.fibrePulled === true;
        }
      );
      this.activeInstallsComplete = this.locationNetworksLocations.filter(
        function(el) {
          return el.equipmentInstalled === true;
        }
      );
    },

    initialize() {
      this.$router.push({name: this.$route.name, query:{offset: '0', records: '20'}})
      // this.deviceCount();
      this.fetchAllPackageCategories();
      // this.getIsps();
      this.fetchDocuments();
      this.fetchCustomers();
      // this.fetchSpeedProfiles();
      this.fetchPackagesFnoTypes();
      this.fetchDevices();
      this.fetchLocationNodes();
      this.fetchRegions();
      this.getAllFnoPackages();
      this.fetchPackagesFnoLocationNetworks();
      this.fetchLocationNetworksLocations();
      this.fetchLocationNetworkSummaryPage();
      this.fetchAllPackagesFnoLocationNetworks();
      this.fetchPackagesIspLocationNetworks();
      this.fetchNetworkDevices();
      this.getNodeDevices();
      // this.getNetworkDevices();
      this.getFibreFarmersOnNetwork();
      this.getTransactions();
      this.getServiceaccounts();
      this.getlocationTypes()
      this.getSubComplexes();
      this.getRecurringTransactions();
      this.fetchProducts()
      this.getStockItems()
    },
    fetchProducts(){
      Api().get('/locationNetworkProduct/byNetwork/'+this.$route.params.locationNetworkId).then(response=>{
        this.locationNetworkProducts=response.data
        console.log(this.locationNetworkProducts)
      })
    },
    goToLocations(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        path: "/locationnetworks/" + this.editedItem.id + "/locations"
      });
    },
    // editItem(item) {
    //   if(this.authUpdate(this.$store.state.currentRoute)){
    //   this.editedIndex = this.locationNetworks.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   this.dialog = true;
    //   }
    // },

    // deleteItem(item) {
    //   if(this.authDelete(this.$store.state.currentRoute)){
    //   const index = this.locationNetworks.indexOf(item);
    //   confirm("Are you sure you want to delete this item?") &&
    //     this.locationNetworks.splice(index, 1);
    //   Api().delete("/locationnetworks/" + this.editedItem.id);
    //   }
    // },

    save() {
      if(this.authUpdate(this.$store.state.currentRoute)){
      if (this.locationNetworkInfo.tvOverFibre === false) {
        this.locationNetworkInfo.gtuIncluded = false;
      }
      if (this.locationNetworkInfo.lineRentalIncluded === false) {
        this.locationNetworkInfo.residentialLineRentalValue = 0;
      }
      Api().put("/locationnetworks/" + this.locationNetworkInfo.id, {
        name: this.locationNetworkInfo.name,
        locationNodeId: this.locationNetworkInfo.locationNodeId,
        lineRentalIncluded: this.locationNetworkInfo.lineRentalIncluded,
        tvOverFibre: this.locationNetworkInfo.tvOverFibre,
        gtuIncluded: this.locationNetworkInfo.gtuIncluded,
        activationFee: this.locationNetworkInfo.activationFee,
        routerInstallationFee: this.locationNetworkInfo.routerInstallationFee,
        residentialLineRentalValue: this.locationNetworkInfo.residentialLineRentalValue,
        businessLineRentalValue: this.locationNetworkInfo.businessLineRentalValue,
        isDeleted: false,
        isActive: this.locationNetworkInfo.isActive
      });
      this.$emit("successfullySaved");

      this.locationNetworks.push(this.editedItem);
      }
      },
       editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      this.editUnitDialog = true;
      }
    },
  async routerLinkToDetails(item) {    
      this.locationdetail = item;
      let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/locationNetworks/:locationNetworkId/:locationId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        path:
          "/locationNetworks/" +
          this.editedItem.locationNetworkId +
          "/" +
          this.editedItem.id
      });
    },
    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/locations/" + this.editedItem.id, {
        isActive: false,
        isDeleted: true
      }).then(response=>{
         this.fetchLocation()   
      })
      }
    },
    fetchLocation(){
      Api()
        .get('/locations/byNetwork/'+this.$route.params.locationNetworkId+'/activeFilter',{
          params: {
          search: this.$route.query.search,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.locationNetworksLocations=response.data.result
          this.locationLength=response.data.count
          this.locationKey +=1
            this.loading=false
          })
    },
    saveEditLocation() {
        let proceed = true;
       if (this.editedItem.locationDescription == "") {
        this.editedItem.locationDescription =
        (this.editedItem.unitNo || "") +
            " " +
            (this.editedItem.complexStreetName || "") +
            " " +
            (this.editedItem.subComplexName || "") +
            " " +
            (this.editedItem.complexName || "")
      }
       if (this.editedItem.locationTypeId == "") {
        proceed = false;
        confirm("Please select a location type.");
      }
       if (this.editedItem.unitNo == "") {
        proceed = false;
        confirm("Please fill in an unit number.");
      }
       if (this.editedItem.complexName == "") {
        proceed = false;
        confirm("Please fill in a complex name.");
      }
     
      if (proceed == true) {
      Api().put("/locations/" + this.editedItem.id, {
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,
        locationNetworkId: this.$route.params.locationNetworkId
      }).then(response=>{ 
        
        if(response.status===200){
            this.text = "Unit Successfully Updated!";
            this.snackbar = true;
          }   
          this.fetchLocation()        
      });;
      this.close();     
      
      }
    },
      saveNewUnit() {
       let proceed = true;
        this.editedItem.locationNetworkId=this.$route.params.locationNetworkId
      if (this.editedItem.locationDescription == "") {
        this.editedItem.locationDescription =
        (this.editedItem.unitNo || "") +
            " " +
            (this.editedItem.complexStreetName || "") +
            " " +
            (this.editedItem.subComplexName || "") +
            " " +
            (this.editedItem.complexName || "")
      }
       if (this.editedItem.locationTypeId == null) {
        proceed = false;
        confirm("Please select a location type.");
      }
       if (this.editedItem.unitNo == "") {
        proceed = false;
        confirm("Please fill in an unit number.");
      }
       if (this.editedItem.complexName == "") {
        proceed = false;
        confirm("Please fill in a complex name.");
      }
      if (proceed == true) {
       
   Api().post("/locations", {
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,
        locationNetworkId: this.editedItem.locationNetworkId
      }).then(response=>{        
             if(response.status===200){
            this.text = "Unit Successfully Added!";
            this.snackbar = true;
          } 
          this.close(); 
           this.fetchLocation()   
        })     
   
      

      }
      }
    
    
  }
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
